/**
 * @flow
 * @relayHash 837010d1547bd43d9d6d0ebb21460b4c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Screen_config$ref = any;
type Screen_screen$ref = any;
export type AppQueryVariables = {|
  index?: ?number
|};
export type AppQueryResponse = {|
  +screen: ?{|
    +$fragmentRefs: Screen_screen$ref
  |},
  +screenConfig: ?{|
    +$fragmentRefs: Screen_config$ref
  |},
|};
*/


/*
query AppQuery(
  $index: Int
) {
  screen(index: $index) {
    ...Screen_screen
    id
  }
  screenConfig: infoMonitorConfig {
    ...Screen_config
    id
  }
}

fragment Screen_screen on Screen {
  id
  index
  rowset {
    fields {
      name
      label
    }
    rows
  }
  name
  html
  json
  duration
  contentType
  dataSource
}

fragment Screen_config on InfoMonitorConfig {
  id
  screenConfigs {
    index
    name
  }
  screenSequence
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "index",
    "type": "Int",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "index",
    "variableName": "index",
    "type": "Int"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "index",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "AppQuery",
  "id": null,
  "text": "query AppQuery(\n  $index: Int\n) {\n  screen(index: $index) {\n    ...Screen_screen\n    id\n  }\n  screenConfig: infoMonitorConfig {\n    ...Screen_config\n    id\n  }\n}\n\nfragment Screen_screen on Screen {\n  id\n  index\n  rowset {\n    fields {\n      name\n      label\n    }\n    rows\n  }\n  name\n  html\n  json\n  duration\n  contentType\n  dataSource\n}\n\nfragment Screen_config on InfoMonitorConfig {\n  id\n  screenConfigs {\n    index\n    name\n  }\n  screenSequence\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "AppQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "screen",
        "storageKey": null,
        "args": v1,
        "concreteType": "Screen",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Screen_screen",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": "screenConfig",
        "name": "infoMonitorConfig",
        "storageKey": null,
        "args": null,
        "concreteType": "InfoMonitorConfig",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Screen_config",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "AppQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "screen",
        "storageKey": null,
        "args": v1,
        "concreteType": "Screen",
        "plural": false,
        "selections": [
          v2,
          v3,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "rowset",
            "storageKey": null,
            "args": null,
            "concreteType": "RowSet",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "fields",
                "storageKey": null,
                "args": null,
                "concreteType": "FieldDefinition",
                "plural": true,
                "selections": [
                  v4,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "label",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "rows",
                "args": null,
                "storageKey": null
              }
            ]
          },
          v4,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "html",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "json",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "duration",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "contentType",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "dataSource",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": "screenConfig",
        "name": "infoMonitorConfig",
        "storageKey": null,
        "args": null,
        "concreteType": "InfoMonitorConfig",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "screenConfigs",
            "storageKey": null,
            "args": null,
            "concreteType": "ScreenConfig",
            "plural": true,
            "selections": [
              v3,
              v4
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "screenSequence",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1777dc898afc68ebb0ced7b15b021c57';
module.exports = node;



// WEBPACK FOOTER //
// ./src/__generated__/AppQuery.graphql.js